export const defaultAiAssistantInfo = {
	title: "Ai Learning Agent",
	alias: "AiLA",
	icon: "https://memorang-prod-media.s3.amazonaws.com/aila-default-icon.png",
	showOriginalQuestion: true,
	initialMessage:
		"👋 Hey there, I'm the **{{alias}}**, your {{title}}, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the question you answered about **{{topic}}.**",
	initialAiMessage: {
		"en-US":
			"👋 Hey there, I'm the **{{alias}}**, your {{title}}, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the question you answered about **{{topic}}.**",
		"zh-CN":
			"👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**",
		"ja-JP":
			"👋 こんにちは、私は **{{alias}}**、あなたの **{{title}}** です！**{{context}}** の準備をより良くするためにお手伝いします。特に、あなたが回答した **{{topic}}** について深掘りしていきましょう。",
	},
};
